import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { RemarksComponent } from 'src/app/admin/menus/events/remarks/remarks.component';
declare let $: any;
@Component({
  selector: 'app-csrsdoc-list',
  templateUrl: './csrsdoc-list.component.html',
  styleUrls: ['./csrsdoc-list.component.css'],
})
export class CsrsdocListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'projectName',
    'spocName',
    'spocMobile',
    'status',
    'remark',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private baseUrl = environment.url;
  private listApi = `${this.baseUrl}csrproject/list`;
  private deleteApi = environment.url + environment.eventDelete;
  /**
   * Initializes a new instance of the CsrsdocListComponent.
   * @param router Service for navigation
   * @param makeapi Service for API requests
   * @param getdata Service for managing values
   * @param http Service for making HTTP requests
   * @param notify Service for sending notifications
   * @param dialog Service for managing dialogs
   */
  constructor(
    private router: Router, // Used for navigating between routes
    private makeapi: ApiService, // Used for making API calls
    private getdata: ValueService, // Used for managing shared data
    private http: HttpClient, // Used for making HTTP requests
    private notify: NotifyService, // Used for notifications
    public dialog: MatDialog // Used for opening dialogs
  ) {
    // Initialize the data source for the table
    this.dataSource = new MatTableDataSource();
  }

  roleValue;
  /**
   * Called when the component is initialized.
   * Sets initial configurations and fetches data.
   */
  ngOnInit(): void {
    // Set the visibility source to true
    this.getdata.isVisibleSource.next(true);

    // Retrieve and set the role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Fetch the list of events
    this.csrdocList();

    // Add 'btnActive' class to elements with class 'all'
    $('.all').addClass('btnActive');

    // Set the initial value for valueGet
    this.valueGet = 'all';

    // Set the status button with parameters
    this.ststusBtn(3, 'all');

    // Fetch the list of CSR projects (possibly paginated)
    this.ListApi();

    // Retrieve CSR projects
    this.getCsrProjects();
  }
  /**
   * Retrieves the list of CSR projects from the API.
   * @returns An Observable of an array of CSR project objects.
   */
  getCsrProjects(): Observable<any[]> {
    const url = `${this.baseUrl}/csrproject/save`;
    /**
     * Makes an API call to fetch the list of CSR projects.
     * Subscribes to the API response and updates the component data.
     */
    return this.http.get<any[]>(url);
  }
  /**
   * Navigates to the home page.
   */
  dataclick() {
    this.router.navigateByUrl('/home');
  }

  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of CSRs from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  csrdocList() {
    // Set the pagination parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };

    // Call the ListApi function to fetch the list of CSRs
    this.ListApi();
  }
  /**
   * Fetches the list of CSRs from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        // Check if the count of data returned is 0
        if (data.count == 0) {
          // If the count is 0, show the "No Data" message
          this.noData = true;
        } else {
          // If the count is not 0, hide the "No Data" message
          this.noData = false;
          // Set the page total count
          this.pageTotalCount = data.count;

          // Set the list of CSRs
          this.disList = data.responsemodelList;

          // Set the MatTableDataSource with the new data
          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }
  /**
   * Lifecycle hook called after the component's view has been fully initialized.
   * Sets the paginator for the MatTableDataSource to enable pagination functionality.
   */
  ngAfterViewInit() {
    // Assign the paginator to the data source
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination event.
   * Updates the page number and page size based on the pagination event.
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Update the page number (convert zero-based index to one-based) and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };

    // Call the API to fetch the updated data
    this.ListApi();
  }
  /**
   * Navigate to the page for adding a new CSR project.
   */
  projectAddBtn() {
    // Navigate to the page for adding a new CSR project
    this.router.navigateByUrl('/csrdocadd');
  }
  /**
   * Deletes a CSR project based on the provided ID.
   * @param id The ID of the CSR project to delete.
   */
  deleteEvent(id: string): void {
    // Create an array with the ID to be deleted
    let getdata = [id];

    // Call the API to delete the project
    this.makeapi.method(this.deleteApi, getdata, 'post').subscribe((data) => {
      // Check if the response status is success
      if (data.responseStatus == 'Success') {
        // Notify the user of the success
        this.notify.notifysuccess(data.responseMessage);
        // Call the list API to refresh the list
        this.csrdocList();
      } else {
        // Notify the user of the error
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  /**
   * Navigates to the CSR project details page with the given project id as a query parameter.
   * @param id The ID of the CSR project to navigate to.
   */
  eventnames(id: string): void {
    this.getdata.csrprojectId(btoa(id));
  }
  /**
   * Updates the list object to fetch pending events and calls the ListApi function
   * to refresh the list of events.
   */
  pending() {
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      status: 0,
    };
    this.ListApi();
  }
  valueGet;
  butActClass;
  /**
   * Changes the status of the event list and updates the list by calling ListApi()
   * @param value - The status of the event
   * @param name - The class name associated with the status button
   */
  ststusBtn(value: number, name: string) {
    // Remove the active class from all status buttons
    $('.all').removeClass('btnActive');
    // Store the status value
    this.valueGet = value;
    // Remove the active class from the current status button
    $(this.butActClass).removeClass('btnActive');
    // Store the class name of the current status button
    this.butActClass = '.' + name;
    // Add the active class to the current status button
    $(this.butActClass).addClass('btnActive');

    // If the status is not 3, add the status to the list
    if (value != 3) {
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
        status: this.valueGet,
      };
    } else {
      // Otherwise, do not add the status to the list
      this.list = {
        listSize: this.pageSize,
        pageNumber: this.pageNumber,
      };
    }

    // Call ListApi() to update the list
    this.ListApi();
  }
  /**
   * Opens a dialog to view the description details.
   * @param status - The status associated with the description.
   * @param title - The title of the description.
   */
  viewDescrptionBtn(status: string, title: string) {
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });
    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
